import BankCardStatus from "./BankCardStatus";

export default BankCardStatus;
